import { Injectable } from '@angular/core';
import { HttpRequest, HttpHandler, HttpEvent, HttpInterceptor } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from 'environments/environment';
import { encrypt } from './../_services/security.service';

import { AuthenticationService } from '../_services';

@Injectable()
export class DocManagerInterceptor implements HttpInterceptor {

  private excludeUrl = environment.DOC_MANAGER_LAMBDA_PROD;
  private excludeUrlMailer = environment.EMAIL_SENDER_LAMDBA
  private encryptData = environment.encryptData;
  


  constructor(private authenticationService: AuthenticationService) { }

  intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    // add authorization header with jwt token if available
    let currentUser = this.authenticationService.currentUserValue;

    if (this.isLambdaUrl(request.url) && currentUser && currentUser.LoginSessionKey && this.encryptData) {

      const encrypted = encrypt(JSON.stringify(request.body));

      request = request.clone({
        body: { info: encrypted, debug: environment.encryptData }
      });

    }

    return next.handle(request);
  }

  isLambdaUrl(url: string) {

    if (url === this.excludeUrl || url === this.excludeUrlMailer) {
      return true;
    } else {
      return false;
    }
  }
}